// extracted by mini-css-extract-plugin
export default {"root":"header_root__+jQkF"};